<script setup>
import {ref, onMounted, nextTick} from 'vue'

const props = defineProps({
  content: String,
  showAfter: {
    type: Number,
    default: 1200
  },
  placement: {
    type: String,
    default: 'top'
  },
  isOverflow: {
    type: Boolean,
    default: false
  }
})

const wrapperRef = ref(null)
const isOverflow = ref(false)

onMounted(() => {
  nextTick(() => {
    const el = wrapperRef.value
    if (el) {
      if (props.isOverflow) {
        isOverflow.value = true
      } else {
        isOverflow.value = el.scrollWidth > el.offsetWidth
      }
    }
  })
})
</script>

<template>
  <el-tooltip
      v-if="isOverflow"
      effect="dark"
      :show-after="showAfter"
      :placement="placement"
  >
    <!-- tooltip 内容限制宽高并支持滚动 -->
    <template #content>
      <div class="tooltip-content-box">
        {{ content }}
      </div>
    </template>
    <div ref="wrapperRef" class="ellipsis-content">
      <slot/>
    </div>
  </el-tooltip>

  <!-- 无需 tooltip 时直接显示 -->
  <div
      v-else
      ref="wrapperRef"
      class="ellipsis-content"
  >
    <slot/>
  </div>
</template>

<style scoped>
.ellipsis-content {
  max-width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  cursor: pointer;
}

/* tooltip 内容区域的宽高和滚动控制 */
.tooltip-content-box {
  max-width: 300px;
  max-height: 200px;
  overflow: auto;
  word-break: break-all;
  white-space: normal;
  cursor: pointer;
}
</style>